"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMinutesDifference = getMinutesDifference;
/**
 * Gets the time difference in minutes given two timestamps
 * @param {number} startTime
 * @param {number} finishTime
 */
function getMinutesDifference(startTime, finishTime) {
  var difference = Math.abs(finishTime - startTime);
  return Math.floor(difference / 1000 / 60); // milliseconds / seconds
}